import React from "react";
import { Input } from "./_shared";
import { resolveUrl } from "../../../lib/api";

export default function BrandTab({ settings, setSettings, t, saveBrand, uploadLogo, removeLogo }) {
  return (
    <section className="card-surface p-5 sm:p-8">
      <h2 className="font-serif text-xl sm:text-2xl mb-6">{t("admin.brandSection")}</h2>
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <Input label="Nume brand" value={settings.brand_name} onChange={(v) => setSettings({...settings, brand_name: v})} testid="setting-brand-name" />
        <Input label="Default lang" value={settings.default_lang} onChange={(v) => setSettings({...settings, default_lang: v})} testid="setting-lang" />
        <Input label="Tagline RO" value={settings.tagline_ro || ""} onChange={(v) => setSettings({...settings, tagline_ro: v})} testid="setting-tagline-ro" />
        <Input label="Tagline EN" value={settings.tagline_en || ""} onChange={(v) => setSettings({...settings, tagline_en: v})} testid="setting-tagline-en" />
        <Input label="Valuta default" value={settings.default_currency} onChange={(v) => setSettings({...settings, default_currency: v})} testid="setting-currency" />
        <Input label="Curs EUR → RON" type="number" value={settings.exchange_rate_eur_to_ron} onChange={(v) => setSettings({...settings, exchange_rate_eur_to_ron: v})} testid="setting-rate" />
      </div>

      <h3 className="label-eyebrow mb-3">{t("admin.logoUpload")}</h3>
      <div className="flex items-center gap-4 mb-4">
        {settings.logo_path ? <img src={resolveUrl(settings.logo_path)} className="h-12 bg-white/10 p-2" alt="" /> : <div className="text-xs" style={{ color: "var(--brand-text-secondary)" }}>Niciun logo</div>}
        <label className="btn-ghost cursor-pointer">
          {t("admin.uploadLogo")}
          <input type="file" accept="image/*" className="hidden" onChange={uploadLogo} data-testid="upload-logo-input" />
        </label>
        {settings.logo_path && <button onClick={removeLogo} className="btn-ghost" data-testid="remove-logo">{t("admin.removeLogo")}</button>}
      </div>
      <label className="flex items-center gap-2 mb-6 text-sm cursor-pointer">
        <input type="checkbox" checked={!!settings.logo_only_mode} onChange={(e) => setSettings({...settings, logo_only_mode: e.target.checked})} data-testid="logo-only-toggle" />
        Afiseaza doar logo (ascunde numele brandului pe site & email-uri) — necesita logo incarcat
      </label>

      <h3 className="label-eyebrow mb-3">{t("admin.colors")}</h3>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3 mb-6">
        {Object.entries(settings.colors || {}).map(([k, v]) => (
          <div key={k} className="flex items-center gap-2">
            <input type="color" value={v} onChange={(e) => setSettings({...settings, colors: {...settings.colors, [k]: e.target.value}})} className="w-12 h-10 border-0 cursor-pointer" data-testid={`color-${k}`} />
            <input value={v} onChange={(e) => setSettings({...settings, colors: {...settings.colors, [k]: e.target.value}})} className="brand-input flex-1 text-xs" />
            <span className="text-xs whitespace-nowrap" style={{ color: "var(--brand-text-secondary)" }}>{k}</span>
          </div>
        ))}
      </div>

      <h3 className="label-eyebrow mb-3">{t("admin.contactSection")}</h3>
      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        <Input label="Telefon" value={settings.contact?.phone || ""} onChange={(v) => setSettings({...settings, contact: {...settings.contact, phone: v}})} testid="contact-phone" />
        <Input label="Email" value={settings.contact?.email || ""} onChange={(v) => setSettings({...settings, contact: {...settings.contact, email: v}})} testid="contact-email" />
        <Input label="Adresa" value={settings.contact?.address || ""} onChange={(v) => setSettings({...settings, contact: {...settings.contact, address: v}})} testid="contact-address" />
      </div>

      <button onClick={saveBrand} className="btn-gold-filled" data-testid="save-brand">{t("common.save")}</button>
    </section>
  );
}
